
<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>

      <div id="viz"></div>

      <v-flex>
        <v-card dark>
          <!--<user-activity-apex :seriesp="dataPoints"></user-activity-apex>-->
          <template v-for="user in users">
            <individual-user-graph :username='user.local.email' :interval="30"></individual-user-graph>
          </template>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import IndividualUserGraph from '../../components/graphs/IndividualUserActivity'
  import UserActivityApex from '../../components/graphs/UserActivityApex.vue'

  export default {
    components: {
      IndividualUserGraph,
      UserActivityApex
    },
    data () {
      return {
        labels: [],
        dataPoints: [],
        height: 20,
        sampleSeries: [{
          name: 'series-1',
          data: [30, 40, 45, 50, 49, 60, 70, 91]
        }, {
          name: 'series-2',
          data: [23, 43, 54, 12, 44, 52, 32, 11]
        }],
        users: [],
        visualization: []
      }
    },
    methods: {
      increaseHeight () {
        this.height += 10
      },
      getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      },
      fillData () {
        var chartColors = {
          red: 'rgb(255, 99, 132)',
          orange: 'rgb(255, 159, 64)',
          yellow: 'rgb(255, 205, 86)',
          green: 'rgb(75, 192, 192)',
          blue: 'rgb(54, 162, 235)',
          purple: 'rgb(153, 102, 255)',
          grey: 'rgb(231,233,237)'
        };

        this.dataPoints = {
          labels: this.labels,
          datasets: [
            {
              label: 'Data One',
              backgroundColor: 'transparent',
              borderColor: chartColors.red,
              lineTension: 0,
              data: this.dataPoints,

            }
          ]
        }
      },
      loadUserList() {
        var _this = this;
        this.$http.get('/panel/user/list', {
          headers: {
            'Authorization': localStorage.getItem('jwtToken')
          }
        })
          .then(response => {
            console.log("GOT USER LIST")
            _this.users = response.data
            console.log(_this.users);
          })
          .catch(e => {
            _this.$root.$emit('snackbar', 'Error retrieving user list!')
          })
      },
      buildBubbleJobChart(sample_data) {
        // instantiate d3plus
        this.visualization = d3plus.viz()
          .container("#viz")     // container DIV to hold the visualization
          .data(sample_data)     // data to use with the visualization
          .type("bubbles")       // visualization type
          .id(["date", "job_id"]) // nesting keysx
          .depth(1)              // 0-based depth
          .size("size")         // key name to size bubbles
          .color("date")
          .order({"sort":"asc", "value": "date"})// color by each group
          .draw()                // finally, draw the visualization!
      }
    },
    computed: {
      myStyles () {
        return {
          height: `${this.height}px`,
          position: 'relative'
        }
      }
    },
    mounted: function() {
      console.log("MOUNTED LIVESTATS")
      this.loadUserList();

      var _this = this;
      this.$http.get('/stats/jobcounts', {
        headers: {
          'Authorization': localStorage.getItem('jwtToken')
        }
      })
        .then(response => {
          var sample_data = response.data;


          _this.buildBubbleJobChart(sample_data)

          //
          // mounted () {
          //   setInterval(() => {
          //     this.fillData()
          //   }, 1000)
          // },

        })
        .catch(e => {
          _this.$root.$emit('snackbar', 'Error retrieving job count bubbles!')
        })

    }
  }
</script>

<style>
  #viz {
    height: 1080px;
    width: auto;
  }
  h1 {
    font-family: 'Helvetica', Arial;
    color: #464646;
    text-transform: uppercase;
    border-bottom: 1px solid #f1f1f1;
    padding-bottom: 15px;
    font-size: 28px;
    margin-top: 0;
  }
  .Chart {
    padding: 20px;
    box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, .4);
    border-radius: 20px;
    margin: 50px 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/admin/LiveStats.vue